<template>
  <CContainer fluid>
    <CRow alignHorizontal="between">
      <div class="row-card-title left">
        <div>
          <div class="card-title-active">All User</div>
          <div class="line" />
        </div>
      </div>
      <div class="row-card-title right">
        <div>
          <div class="button button-icon button-green" @click="goToReportAndExport()">
            Export Report
            <img src="@/assets/images/admin/Download.svg" class="icon icon-invert" />
          </div>
        </div>
      </div>
    </CRow>
    <CRow>
      <div class="main-card">
        <CContainer fluid>
          <CRow>
            <div class="button button-icon button-orange" @click="setIsAddNewUserModalShow()">
              Add User
              <img src="@/assets/images/admin/Plus.svg" class="icon" />
            </div>
          </CRow>
          <CRow
            alignHorizontal="end"
            alignVertical="center"
            class="row-header"
            style="font-size: 20px"
          >
            <div class="mr-1 ml-1" style="color: #CCCCCC;">showing</div>
            <div
              style="font-weight: bold; color:#FB9879;"
            >{{pagination.showing.start}}-{{paginationEnd(pagination.showing.end)}} of {{pagination.all}}</div>
            <template>
              <img
                v-if="pagination.showing.start==1"
                src="@/assets/images/admin/PreviousAdmin2.svg"
                class="mr-1 ml-1 icon disable"
              />
              <img
                v-else
                src="@/assets/images/admin/PreviousAdmin.svg"
                class="mr-1 ml-1 icon"
                @click="previous()"
              />
            </template>
            <template>
              <img
                v-if="pagination.showing.end<pagination.all"
                src="@/assets/images/admin/NextAdmin.svg"
                class="mr-1 ml-1 icon"
                @click="next()"
              />
              <img v-else src="@/assets/images/admin/NextAdmin2.svg" class="mr-1 ml-1 icon disable" />
            </template>
          </CRow>
          <CRow>
            <table>
              <tr style="font-weight: bold">
                <th>NUM</th>
                <th style="width: 15%">USER ID</th>
                <th style="width: 15%">NAME</th>
                <th style="width: 15%">E-MAIL</th>
                <th style="width: 15%">VERIFIED</th>
                <th style="width: 15%">STATUS</th>
                <th style="width: 15%">ROLE</th>
                <th>ACTION</th>
              </tr>
              <tr>
                <th></th>
                <th>
                  <div class="input-group-search-table">
                    <input placeholder="BY ID" v-model="keyword.id" class="custom-input" />
                    <img
                      @click="findItem('userid', keyword.id)"
                      src="@/assets/images/admin/Search.svg"
                      class="icon icon-search"
                    />
                  </div>
                </th>
                <th>
                  <div class="input-group-search-table">
                    <input placeholder="BY NAME" v-model="keyword.name" class="custom-input" />
                    <img
                      @click="findItem('name', keyword.name)"
                      src="@/assets/images/admin/Search.svg"
                      class="icon icon-search"
                    />
                  </div>
                </th>
                <th>
                  <div class="input-group-search-table">
                    <input placeholder="BY E-MAIL" v-model="keyword.email" class="custom-input" />
                    <img
                      @click="findItem('email', keyword.email)"
                      src="@/assets/images/admin/Search.svg"
                      class="icon icon-search"
                    />
                  </div>
                </th>
                <th>
                  <div class="input-group-search-table">
                    <select id="verified" @change="selectionOnchange" class="input tablesorting">
                      <option value="All">All</option>
                      <option value="Approved">Approved</option>
                      <option value="Pending">Pendding</option>
                      <option value="No verify">No verify</option>
                    </select>
                  </div>
                </th>
                <th>
                  <div class="input-group-search-table">
                    <select id="status" @change="selectionOnchange" class="input tablesorting">
                      <option value="All">All</option>
                      <option value="Active">Active</option>
                      <option value="Off">Off</option>
                    </select>
                  </div>
                </th>
                <th>
                  <div class="input-group-search-table">
                    <select id="role" @change="selectionOnchange" class="input tablesorting">
                      <option value="All">All</option>
                      <option value="User">User</option>
                      <option value="Owner">Owner</option>
                      <option value="Admin">Admin</option>
                    </select>
                  </div>
                </th>
                <th></th>
              </tr>
              <template v-for="item in items">
                <tr :key="item.userid">
                  <td>{{item.id + 1}}</td>
                  <td>{{item.userid}}</td>
                  <td>{{item.name}}</td>
                  <td>{{item.email}}</td>
                  <td style="padding-left: 1%">
                    <div style="display: flex; flex-direction: row;">
                      <c-icon
                        name="cibDiscover"
                        class="icon-space"
                        :style="getVerifedColor(item.verified)"
                      />
                      <div style="font-weight: bold">{{(item.verified).toUpperCase()}}</div>
                    </div>
                  </td>
                  <td>
                    <div
                      style="font-weight: bold"
                      :style="getStatusColor(item.status)"
                    >{{(item.status).toUpperCase()}}</div>
                  </td>
                  <td style="padding-left: 1.5%">
                    <div style="display: flex; flex-direction: row;">
                      <c-icon name="cibDiscover" class="icon-space" style="color: #808080" />
                      <div>{{(item.role[0]).toUpperCase()}}</div>
                    </div>
                  </td>
                  <td>
                    <div class="action">
                      <div @click="setIsUserRoleManageModalShow()">
                        <img src="@/assets/images/admin/Role Management.svg" class="action-icon icon" />
                      </div>
                      <div @click="setIsProfileModalShow()">
                        <img src="@/assets/images/admin/Profile Icon.svg" class="action-icon icon" />
                      </div>
                      <div>
                        <img src="@/assets/images/admin/Mail.svg" class="action-icon icon" />
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </table>
          </CRow>
        </CContainer>
      </div>
    </CRow>
    <AddUser :modalVisible="isAddNewUserModalShow" :setModalVisible="setIsAddNewUserModalShow" />
    <SelectFunction
      :modalVisible="isUserRoleManageModalShow"
      :setModalVisible="setIsUserRoleManageModalShow"
    />
    <ProfileInfo :modalVisible="isProfileModalShow" :setModalVisible="setIsProfileModalShow" />
  </CContainer>
</template>

<script>
import AddUser from "../modal/AddUser";
import SelectFunction from "../modal/roleselection/SelectFunction";
import ProfileInfo from "../modal/ProfileInfo";
import '../../../assets/scss/_adminStyle.scss'

const items = [
  {
    userid: "000000",
    name: "Joe",
    email: "joe@email.com",
    verified: "Approved",
    status: "active",
    role: ["user"]
  },
  {
    userid: "000001",
    name: "Yot",
    email: "yot@gmail.com",
    verified: "Pending",
    status: "off",
    role: ["admin"]
  },
  {
    userid: "000002",
    name: "New",
    email: "New@lamduan.com",
    verified: "No Verify",
    status: "active",
    role: ["owner"]
  },
  {
    userid: "000003",
    name: "Warn",
    email: "Manao@email.com",
    verified: "Approved",
    status: "active",
    role: ["user"]
  },
  {
    userid: "000004",
    name: "Fight",
    email: "useremail",
    verified: "Pending",
    status: "off",
    role: ["admin"]
  },
  {
    userid: "000005",
    name: "Pan",
    email: "useremail",
    verified: "No Verify",
    status: "active",
    role: ["owner"]
  },
  {
    userid: "000006",
    name: "Toon",
    email: "useremail",
    verified: "Approved",
    status: "active",
    role: ["user"]
  },
  {
    userid: "000007",
    name: "Beer",
    email: "useremail",
    verified: "Pending",
    status: "off",
    role: ["admin"]
  },
  {
    userid: "000008",
    name: "fullname",
    email: "useremail",
    verified: "No Verify",
    status: "active",
    role: ["owner"]
  },
  {
    userid: "000009",
    name: "fullname",
    email: "useremail",
    verified: "Approved",
    status: "active",
    role: ["user"]
  },
  {
    userid: "000010",
    name: "fullname",
    email: "useremail",
    verified: "Pending",
    status: "off",
    role: ["admin"]
  },
  {
    userid: "000011",
    name: "fullname",
    email: "useremail",
    verified: "Approved",
    status: "active",
    role: ["user"]
  },
  {
    userid: "000012",
    name: "fullname",
    email: "useremail",
    verified: "Pending",
    status: "off",
    role: ["admin"]
  },
  {
    userid: "000013",
    name: "fullname",
    email: "useremail",
    verified: "No Verify",
    status: "active",
    role: ["owner"]
  },
  {
    userid: "000014",
    name: "fullname",
    email: "useremail",
    verified: "Approved",
    status: "active",
    role: ["user"]
  },
  {
    userid: "000015",
    name: "fullname",
    email: "useremail",
    verified: "Pending",
    status: "off",
    role: ["admin"]
  },
  {
    userid: "000016",
    name: "fullname",
    email: "useremail",
    verified: "Approved",
    status: "active",
    role: ["user"]
  },
  {
    userid: "000017",
    name: "fullname",
    email: "useremail",
    verified: "Pending",
    status: "off",
    role: ["admin"]
  },
  {
    userid: "000018",
    name: "fullname",
    email: "useremail",
    verified: "No Verify",
    status: "active",
    role: ["owner"]
  },
  {
    userid: "000019",
    name: "fullname",
    email: "useremail",
    verified: "Approved",
    status: "active",
    role: ["user"]
  },
  {
    userid: "000020",
    name: "fullname",
    email: "useremail",
    verified: "Pending",
    status: "off",
    role: ["admin"]
  },
  {
    userid: "000021",
    name: "fullname",
    email: "useremail",
    verified: "Approved",
    status: "active",
    role: ["user"]
  },
  {
    userid: "000022",
    name: "fullname",
    email: "useremail",
    verified: "Pending",
    status: "off",
    role: ["admin"]
  },
  {
    userid: "000023",
    name: "fullname",
    email: "useremail",
    verified: "No Verify",
    status: "active",
    role: ["owner"]
  },
  {
    userid: "000024",
    name: "fullname",
    email: "useremail",
    verified: "Approved",
    status: "active",
    role: ["user"]
  },
  {
    userid: "000025",
    name: "fullname",
    email: "useremail",
    verified: "Pending",
    status: "off",
    role: ["admin"]
  }
];

const fields = [
  { key: "num", label: "NUM", filter: false },
  { key: "userid", label: "USER ID" },
  { key: "name", label: "NAME" },
  { key: "email", label: "E-MAIL" },
  { key: "verified", label: "VERIFIED" },
  { key: "status", label: "STATUS" },
  { key: "role", label: "ROLE" },
  { key: "action", label: "ACTION", filter: false }
];

export default {
  components: {
    AddUser,
    SelectFunction,
    ProfileInfo
  },
  name: "allUser",
  data() {
    return {
      isAddNewUserModalShow: false,
      isUserRoleManageModalShow: false,
      isProfileModalShow: false,
      allUser: [],
      items: [],
      fields,
      pagination: {
        all: null,
        showing: {
          start: 1,
          end: 20
        }
      },
      keyword: {
        id: null,
        name: null,
        email: null
      }
    };
  },
  create() {},
  mounted() {
    this.getAllUser();
    this.setRenderingUser(
      this.pagination.showing.start,
      this.pagination.showing.end
    );
  },
  methods: {
    getAllUser() {
      this.allUser = items.map((item, id) => {
        return { ...item, id };
      });
      this.pagination.all = this.allUser.length;
    },
    setRenderingUser(start, end) {
      this.items = [];
      if (this.pagination.all < end) {
        for (let i = start - 1; i < this.pagination.all; i++) {
          this.items.push(this.allUser[i]);
        }
      } else if (this.pagination.all > end) {
        for (let i = start - 1; i < end; i++) {
          this.items.push(this.allUser[i]);
        }
      }
    },
    paginationEnd(end) {
      if (this.pagination.all < end) return this.pagination.all;
      else return end;
    },
    previous() {
      this.pagination.showing.start = this.pagination.showing.start - 20;
      this.pagination.showing.end = this.pagination.showing.end - 20;
      this.setRenderingUser(
        this.pagination.showing.start,
        this.pagination.showing.end
      );
    },
    next() {
      this.pagination.showing.start = this.pagination.showing.start + 20;
      this.pagination.showing.end = this.pagination.showing.end + 20;
      this.setRenderingUser(
        this.pagination.showing.start,
        this.pagination.showing.end
      );
    },
    findItem(targetTo, keyWord) {
      this.items = [];
      if (targetTo == "userid") {
        for (let i = 0; i <= this.allUser.length; i++) {
          let eachItem = this.allUser[i];
          if (eachItem.userid.match(keyWord)) this.items.push(this.allUser[i]);
        }
      } else if (targetTo == "name") {
        for (let i = 0; i <= this.allUser.length; i++) {
          let eachItem = this.allUser[i];
          if (eachItem.name.match(keyWord)) this.items.push(this.allUser[i]);
        }
      } else if (targetTo == "email") {
        for (let i = 0; i <= this.allUser.length; i++) {
          let eachItem = this.allUser[i];
          if (eachItem.email.match(keyWord)) this.items.push(this.allUser[i]);
        }
      }
    },
    selectionOnchange() {
      this.items = [];
      switch (event.target.id) {
        case "verified":
          for (let i = 0; i <= this.allUser.length; i++) {
            let eachItem = this.allUser[i].verified;
            if (eachItem.toLowerCase().match(event.target.value.toLowerCase()))
              this.items.push(this.allUser[i]);
          }
          break;
        case "status":
          for (let i = 0; i <= this.allUser.length; i++) {
            let eachItem = this.allUser[i].status;
            if (eachItem.toLowerCase().match(event.target.value.toLowerCase()))
              this.items.push(this.allUser[i]);
          }
          break;
        case "role":
          for (let i = 0; i <= this.allUser.length; i++) {
            let eachItem = this.allUser[i].role[0];
            if (eachItem.toLowerCase().match(event.target.value.toLowerCase()))
              this.items.push(this.allUser[i]);
          }
          break;
      }
    },
    setIsAddNewUserModalShow() {
      this.isAddNewUserModalShow = !this.isAddNewUserModalShow;
    },
    setIsUserRoleManageModalShow() {
      this.isUserRoleManageModalShow = !this.isUserRoleManageModalShow;
    },
    setIsProfileModalShow() {
      this.isProfileModalShow = !this.isProfileModalShow;
    },
    getVerifedColor(status) {
      switch (status) {
        case "Approved":
          return "color: #0BB190";
        case "Pending":
          return "color: #F2DE79";
        case "No Verify":
          return "color: #F27979";
      }
    },
    getStatusColor(status) {
      switch (status) {
        case "active":
          return "color: #0BB190";
        case "off":
          return "color: #000000";
      }
    },
    goToReportAndExport() {
      this.$router.push("/report-and-export");
    }
  }
};
</script>
